import i18next from 'i18next';

i18next
    .init({
        keySeparator: false,
        interpolation: {
            // React already does escaping
            escapeValue: false,
        },
        lng: 'English', // 'English'
        resources: {
            Srpski: {
                translation: require('./translations/sr.json')
            },
            English: {
                translation: require('./translations/en.json')
            },
            Hrvatski: {
                translation: require('./translations/cr.json')
            },
            French: {
                translation: require('./translations/fr.json')
            },
            Slovenščina: {
                translation: require('./translations/sl.json')
            },
        },
    })

export default i18next